<template>
  <div>
  <b-container>
    <b-row>
      <div class="table-responsive">
        <b-table 
          id="my-table" 
          striped 
          hover
          bordered
          show-empty 
          small
          :items="content_list"
          :fields="fields"
          :current-page="currentPage"
          primary-key="guid"
          class="mb-2"
          head-variant="dark"
          :per-page="perPage"
          thead-class="thead-light"
          tbody-tr-class="text-dark"
          :empty-text="'No Announcements to Display'"
        />
      </div>
      
      <!-- Pagination Controls -->
      <b-pagination
        v-model="currentPage"
        :total-rows="totalRows"
        :per-page="perPage"
        aria-controls="my-table"
        size="sm"
        class="mt-3"
        align="center"
      ></b-pagination>
    </b-row>
  </b-container>
  </div>
</template>

<script>
import announcementApi from "@/services/announcementApiService";
import store from "@/store/store";

export default {
  name: 'unitAnnouncements',
  props: {
  },
  data () {
    return {
      fields: [
        { key: "announcement", sortable: false, label: "Message"},
        { key: "createdBy", sortable: false, label: "Created by"},
        { key: "creationDate", sortable: false, label: "Created on"}
      ],
      totalRows: 0,
      perPage: 10,
      currentPage: 1,
      content_list: []
     }
  },
  mounted () {
    this.getAllAnnouncements()
  },
  methods: {
    getAllAnnouncements(){
      if(!store.getters.getIsLoggedIn) {
        return
      }
        announcementApi.getAnnouncements().then(result => {
          result.content.map(announcement => {
                if( announcement.creationDate != null) {
                  announcement.creationDate = new Date(announcement.creationDate).toLocaleString();
                }
              });
          this.content_list = result.content;
          this.totalRows = result.content.length;
        })
    }
  }
}
</script>
